import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
class LeadsByWilayahMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Leads By Wilayah"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    {
                    this.props.leadsByRegion.map((byRegion, index) => {
                        let totalLeads = 0;
                        let totalClosing = 0;
                        let totalClosingRate = 0;
                        let totalValue = 0;

                        return (
                            <Box sx={{mb: "30px"}} key={`region-group-${index}`}>
                                <Box color={"secondary"} sx={{backgroundColor: "#D9E7CB", padding: "5px", borderTopLeftRadius: "5px", borderTopRightRadius: "5px"}}>
                                <Typography variant='h6' component={"div"} textAlign={"center"}>
                                    <strong>{byRegion.region}</strong>
                                </Typography>
                                </Box>
                                {
                                    byRegion.leads.map((lead, index) => {
                                        let leadsCount = lead.leads ? lead.leads.length : 0;
                                        totalLeads += leadsCount;
                                        totalClosing += lead.closingCount;
                                        totalValue += lead.value;
                                        return (
                                            <Accordion key={`key-${index}`}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel1-content"
                                                    id="panel1-header"
                                                >
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12}>
                                                            <Typography component="span">{lead.city}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} textAlign={"left"} sx={{pr: "5px"}}>
                                                            {lead.province} leads
                                                        </Grid>
                                                    </Grid>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                {leadsCount} leads
                                                            </Grid>
                                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                                {lead.closingCount} closing
                                                            </Grid>
                                                        </Grid>
                                                        <Divider />
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                CR : {leadsCount > 0 ? (lead.closingCount/leadsCount*100).toFixed(2).replace(".00", "") : 0}%
                                                            </Grid>
                                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                                Rp {new Intl.NumberFormat("en-id").format(lead.value)}
                                                            </Grid>
                                                        </Grid>
                                                        <Divider />
                                                    </Paper>
                                                </AccordionDetails>
                                            </Accordion>
                                        );
                                    })
                                }
                                <Box color={"secondary"} sx={{backgroundColor: "#D9E7CB", padding: "5px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px"}}>
                                    <Box textAlign={"center"}>
                                        <strong>Total</strong>
                                    </Box>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>{totalLeads} leads</Grid>
                                        <Grid item xs={6} textAlign={"right"}>{totalClosing} closing</Grid>
                                        <Grid item xs={6}>{totalLeads > 0 ? (totalClosing/totalLeads*100).toFixed(2).replace(".00", "") : 0}% CR</Grid>
                                        <Grid item xs={6} textAlign={"right"}>{new Intl.NumberFormat("en-id").format(totalValue)}</Grid>
                                    </Grid>
                                </Box>
                                
                            </Box>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default LeadsByWilayahMobile;